"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _vueSvgicon = _interopRequireDefault(require("vue-svgicon"));
/* eslint-disable */
/* tslint:disable */
// @ts-ignore

_vueSvgicon.default.register({
  'bag': {
    width: 112,
    height: 155,
    viewBox: '0 0 112 155',
    data: '<defs><clipPath id="svgicon_bag_a"><path pid="0" d="M0 0h112v155H0z"/></clipPath></defs><g data-name="Bag – b" clip-path="url(#svgicon_bag_a)"><g data-name="Group 9877" transform="translate(-51.172 -33.232)"><path pid="1" data-name="Path 7348" d="M107.196 37.228a29.508 29.508 0 00-29.469 29.473v9.7H58.17v107.492h97.735V76.4h-19.25v-9.7a29.508 29.508 0 00-29.459-29.472zm0 9.777a19.539 19.539 0 0119.682 19.696v9.7H87.504v-9.7a19.541 19.541 0 0119.692-19.692zM67.949 86.178h9.777v19.5h9.777v-19.5h39.375v19.5h9.777v-19.5h9.475v87.938H67.949z"/><ellipse pid="2" data-name="Ellipse 462" cx="7.5" cy="7" rx="7.5" ry="7" transform="translate(75 101)"/><circle pid="3" data-name="Ellipse 463" cx="7" cy="7" r="7" transform="translate(125 101)"/></g></g>'
  }
});